import AuditLogs from './AuditLogs/pages/AuditLogs';
import AdminDashboard from './Dashboard/pages/Dashboard';
import PatientList from './PatientList/pages/PatientList';
import PatientOrders from './PatientOrder/pages/PatientOrder';
import AdminReport from './Report/pages/AdminReport';
import ManageOffering from './ManageOffering/pages/ManageOffering';
import ReviewQueue from './ReviewQueue/pages/ReviewQueue';
import ReviewDetail from './ReviewQueue/pages/ReviewDetail';
import PromptManagement from './PromptManagement/pages/PromptManagement';
const roled = { allowedRoles: ['admin'] };
const AdminRoutes = [
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
    // allowedRoles: ['admin'],
    ...roled,
  },
  {
    path: '/admin/patient-list',
    element: <PatientList />,
    ...roled,
  },
  {
    path: '/admin/patient-orders/:id',
    element: <PatientOrders />, // 👈 New route for viewing orders
    ...roled,
  },
  {
    path: '/admin/report',
    element: <AdminReport />, // Admin Report selector page
    ...roled,
  },
  {
    path: '/audit-logs',
    element: <AuditLogs />,
    ...roled,
  },
  {
    path: '/admin/manage-offering',
    element: <ManageOffering />,
    ...roled,
  },
  {
    path: '/admin/review-queue',
    element: <ReviewQueue />,
    ...roled,
  },
  {
    path: '/admin/prompt-management',
    element: <PromptManagement />,
    ...roled,
  },
  {
    path: '/admin/review-queue/:id',
    element: <ReviewDetail />,
    ...roled,
  },
];

export default AdminRoutes;
